import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from '../Layout/Home';
import LoginForm from '../Components/LoginForm';




const RoutesConfig = () => {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/" element={<LoginForm/>} />
        <Route path="/:userType/:email/:password" element={<LoginForm />} />
        <Route path="/home" element={<Home/>}/>

      </Routes>
    </BrowserRouter>
  );
};

export default RoutesConfig;
